import { IMobileOrchestrator } from "@nju/data-access-portal-orchestrator";

export function getMappedErrorCodeDescription(
  legacy: IMobileOrchestrator["legacy"],
) {
  // code descriptions: https://dop-orange.atlassian.net/browse/DOP-28419
  const mappedErrorCodes = {
    RC001: `Klient ma ofertę, która uniemożliwia przeniesienie numeru do nju subskrypcja w Twoim kanale.`,
    RC002:
      "Weryfikacja pozytywna. Wystąpił problem techniczny – zgłoś incydent.",
    RC003:
      "Podany numer MSISDN posiada ofertę biznesową. Przeniesienie na ofertę indywidualną do nju subskrypcja nie jest możliwe.",
    RC004: "Na numerze Klienta jest otwarte zamówienie w systemach Orange.",
    RC005: "Numer jest nieaktywny.",
    RC006:
      "Do końca umowy lojalnościowej pozostało Klientowi więcej niż 180 dni.",
    RC007:
      "Weryfikacja pozytywna. Wystąpił problem techniczny – zgłoś incydent.",
    RC008:
      "Migracja nie jest możliwa, ponieważ ten numer jest numerem stacjonarnym.",
    RC009: "Klient ma niekompletne dane osobowe w Orange.",
    RC011: "Klient ma niezgodne dane osobowe w systemach Orange.",
    RC012:
      "Klient ma niezgodne dane osobowe w systemach Orange. Klient oczekuje na weryfikację danych osobowych przez technika.",
    RC013:
      "Klient ma ofertę Orange Flex, która uniemożliwia przeniesienie numeru do nju subskrypcja.",
    RC014: "Numer jest już w ofercie nju subskrypcja.",
  } as const;

  if (!legacy?.feasibilityCode) {
    return;
  }

  return mappedErrorCodes[legacy.feasibilityCode];
}
